'use client'
import { NextIntlClientProvider } from "next-intl";
import NextTopLoader from 'nextjs-toploader';

const timeZone = process.env.NEXT_PUBLIC_TIMEZONE ?? "America/Los_Angeles";

export default function ClientLayout({ children, locale, messages }) {

    function onError(error) {
        if (error.code === 'MISSING_MESSAGE') return;
        console.error('error', error)
    }

    return (
        <NextIntlClientProvider
            locale={locale}
            messages={messages}
            timeZone={timeZone}
            onError={onError}
        >
            <NextTopLoader
                color="#2563eb"
                height={3}
                showSpinner={false}
            />
            {children}
        </NextIntlClientProvider>
    )
}